import 'fslightbox';

// fslightbox s'initialise automatiquement via les attributs data-fslightbox
// Il détecte tous les éléments avec data-fslightbox et crée les instances nécessaires
console.log("fslightbox loaded");

